module.exports = __webpack_public_path__ + "static/media/calis-tile.ba63b03d.png";